'use strict';

const BaseDisplaySettingsService=require('../../../dist-es6/client/services/displaySettingsService');

const NosisDisplaySettings={
use24HourTimeline:!0};let




DisplaySettingsService=class DisplaySettingsService extends BaseDisplaySettingsService{
constructor(socketService){
super(socketService);
}

async getDisplaySettings(){
return NosisDisplaySettings;
}};


module.exports=DisplaySettingsService;
//# sourceMappingURL=nosisDisplaySettingsService.js.map
